import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csfirstpro(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  const right = {
    padding: '0 0 0 '+padding+'rem',
  };
  
return(
      <div>
      <Sides/>

      <Helmet>
 
 <title>Learn Free PHP hello world program Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="php hello world Programming tutorial for beginners.php hello world examples and php beginner examples. CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,php hello world,php print hello world,first php program with xampp,how to run php first program,php first program how to run,first php program using xampp,php first program,how to create first php program in xampp,end for loop Php,First Programming in Php" />
 <link rel="canonical" href="https://www.codeexampler.com/php-first-program" />
 </Helmet>

 <div className='lg:pl-56'>


    <h1 className="m-4 mh1">Basic program in Php</h1>
    <div className="first">
        <a href="/php-operator">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-control-structure">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
 <h2 className="mt-4 mh2">Steps of program in Php:</h2>
<p className="mt-4 para">
1. Inside text editor when we create a Php project so after the name of file name use extension and .php is the extensive use for Php<br/>
2. This ( &#60;?php ) is use to start PHP code. They signify that the program is starting, and you put all code inside this &#60;?php<br/>

3. Print this code by use <span className="bold"> echo</span>.<br/>
<br/>
<span className="bold"> echo("Hello World");</span> <br/> <br/>
4. Console represents the input, output, or error<br/>

5. And after close program by this ( &#62;?php  ) code<br/>
</p>
<h2 className="mt-4 mh2">Php hello world Program how to Run:</h2>


<h2 className="headings">Q-Php hello world Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">?</span>
            <span className="qwerty-6">php</span>
            {"\n"}
            <span className="qwerty-10">echo </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty">Hello </span>
            <span className="qwerty-7">World!</span>
            <span className="qwerty-4">"; </span>
            {"\n"}
              <span className="qwerty-5">? </span>
                <span className="qwerty-3">&#62;</span>
              
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-10">Hello</span>
              <span className="qwerty-8"> World!</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Fundamental for Php programming example :</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">?</span>
            <span className="qwerty-6">php</span>
            {"\n"}
            <span className="qwerty-7">echo </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-5">sports </span>
           
            <span className="qwerty-4">\</span>
            <span className="qwerty-7">n</span>
            <span className="qwerty-4">"; </span>
            {"\n"}
            <span className="qwerty-7">echo </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-6">1</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty">football </span>
            <span className="qwerty-4">\</span>
            <span className="qwerty-7">n</span>
            <span className="qwerty-4">"; </span>
            {"\n"}
            <span className="qwerty-7">echo </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-6">2</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty">badminton </span>
            <span className="qwerty-4">\</span>
            <span className="qwerty-7">n</span>
            <span className="qwerty-4">"; </span>
            {"\n"}
            <span className="qwerty-7">echo </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-6">3</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty">tennis </span>
            <span className="qwerty-4">\</span>
            <span className="qwerty-7">n</span>
            <span className="qwerty-4">"; </span>
            {"\n"}
            <span className="qwerty-7">echo </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-6">4</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty">cricket </span>
            <span className="qwerty-4">\</span>
            <span className="qwerty-7">n</span>
            <span className="qwerty-4">"; </span>
            {"\n"}
            <span className="qwerty-7">echo </span>
            <span className="qwerty-4">\</span>
            <span className="qwerty-7">n</span>
            <span className="qwerty-4">"; </span>
            {"\n"}
            <span className="qwerty-7">echo </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-2">hello</span>
              <span className="qwerty-10"> world program in php</span>
            <span className="qwerty-4">"; </span>
            {"\n"}
              <span className="qwerty-5">? </span>
                <span className="qwerty-3">&#62;</span>
              
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-10">sports </span>
            {"\n"}
            <span className="qwerty-6">1</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty">football </span>
            {"\n"}
            <span className="qwerty-6">2</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty">badminton </span>
            {"\n"}
            <span className="qwerty-6">3</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty">tennis </span>
            {"\n"}
            <span className="qwerty-6">4</span>
            <span className="qwerty-4">,</span>
            <span className="qwerty"> cricket </span>
            {"\n"}
              <span className="qwerty-2">hello</span>
              <span className="qwerty-10"> world program in php</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/php-operator">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-control-structure">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

        </div>
    </div>
)

}
export default Csfirstpro;